// Copyright (c) 2017 Deere & Company

import React, {PropTypes} from 'react';
import {FormattedMessage} from 'react-intl';

const ReportVariantModalHeader = props =>
    <header>
        <span>
            <FormattedMessage id={props.headerText}/>
        </span>
        <span
            className='close-modal-icon'
            onClick={props.onCloseButtonClick}
        />
    </header>;

ReportVariantModalHeader.displayName = 'ReportVariantModalHeader';
ReportVariantModalHeader.propTypes = {
    headerText: PropTypes.string.isRequired,
    onCloseButtonClick: PropTypes.func.isRequired
};

export default ReportVariantModalHeader;



// WEBPACK FOOTER //
// ./src/reports/shared/components/report-variant-modals/report-variant-modal-header.js